export default __webpack_public_path__ + "static/img_3_1-eacb403114ee2087f557f68c0ea0ded9.jpg";